import { FacebookIcon, FooterCopyright, FooterIcons, FooterLogo, FooterSection, FooterWrapper, HomeButton, InstagramIcon } from "./styled";
import Logo from "./logo_CMYK_biale.png"
import { ReactComponent as ArrowIcon } from "./arrow.svg";

const Footer = () => (
    <>

        <FooterSection>
            <HomeButton to="home" smooth={true} duration={2000} offset={-90}>
                <ArrowIcon />
            </HomeButton>
            <FooterWrapper>
                <FooterLogo src={Logo} />
                <FooterIcons>
                    <a href="https://www.facebook.com/przystanczorsztynianka" target="_blank" title="Facebook" rel="noreferrer">
                        <FacebookIcon />
                    </a>
                    <a href="https://www.instagram.com/czorsztynianka/" target="_blank" title="Instagram" rel="noreferrer">
                        <InstagramIcon />
                    </a>
                </FooterIcons>
                <FooterCopyright>
                    <span>Czorsztynianka</span>
                    <span>© Copyright 2025</span>
                </FooterCopyright>
            </FooterWrapper>
        </FooterSection>
    </>
);


export default Footer;